const single_sign_on = {
    forbidden_domains: 'Los dominios de correo electrónico público no están permitidos.',
    duplicated_domains: 'Hay dominios duplicados.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
